export interface AppSectionHome {
  path: string;
  label: string;
  /** Short phrase for inline copy, e.g. "return to Admin". */
  returnPhrase: string;
}

/** Primary escape hatch for 404/error pages based on the current URL section. */
export function getAppSectionHome(pathname: string): AppSectionHome {
  if (pathname.startsWith('/admin')) {
    return {
      path: '/admin',
      label: 'Back to Admin',
      returnPhrase: 'return to Admin',
    };
  }
  if (pathname.startsWith('/planning')) {
    return {
      path: '/planning',
      label: 'Back to Budget Planning',
      returnPhrase: 'return to Budget Planning',
    };
  }
  // DISABLED: Current Expense section home (see docs/DISABLED_FEATURES.md Feature #11)
  // if (pathname.startsWith('/expense')) {
  //   return {
  //     path: '/expense',
  //     label: 'Back to Current Expense',
  //     returnPhrase: 'return to Current Expense',
  //   };
  // }
  if (pathname.startsWith('/help')) {
    return {
      path: '/help',
      label: 'Back to Help Center',
      returnPhrase: 'return to Help Center',
    };
  }
  return {
    path: '/',
    label: 'Back to Dashboard',
    returnPhrase: 'return to the dashboard',
  };
}
